const TRUE_STRING = '1';
const FALSE_STRING = '0';

export function convertBooleanToQueryStringValue(booleanValue : boolean | null) {
    if (null === booleanValue || undefined === booleanValue) {
       return null;
    }

    return booleanValue ? TRUE_STRING : FALSE_STRING;
}

export function convertBooleanInputValueToBoolean(booleanInputValue : '1' | '0' | null) {
    if (!booleanInputValue) {
        return null;
    }

    return booleanInputValue === TRUE_STRING;
}

export function convertBooleanToDisplayValue(booleanValue : boolean | null) {
    if (null === booleanValue || undefined === booleanValue) {
        return null;
    }

    return booleanValue ? 'Oui' : 'Non';
}